var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tooltip',{attrs:{"target":_vm.targetSelector}},[(_vm.lea)?_c('span',[_c('lea-icon',{attrs:{"lea":_vm.lea,"svg-mode":true}}),_vm._v(" "+_vm._s(_vm.lea.name)+" ("+_vm._s(_vm.lea.number)+")\n  ")],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }